import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchSession, login, logout } from './api';

/** Session en cours. `retry: false` : un 401 doit renvoyer vers /login sans délai. */
export const sessionQueryOptions = queryOptions({
  queryKey: ['auth', 'session'] as const,
  queryFn: fetchSession,
  retry: false,
});

export function useLogin() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: login,
    onSuccess: (user) => {
      queryClient.setQueryData(sessionQueryOptions.queryKey, user);
    },
  });
}

export function useLogout() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      queryClient.setQueryData(sessionQueryOptions.queryKey, undefined);
      queryClient.clear();
    },
  });
}
